<template>
  <copy-shell
    :dialog-show="dialogShow"
    :is-shop-car="true"
    :title-drawer="$t('Delivery_address')"
    @close="closeHandle"
  >
    <div class="drawer-content-inner shipping-address"
    >
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
        >
          <el-form-item
            :label="$t('Consignees_name')"
            prop="name"
          >
            <el-input
              :placeholder="$t('please_input')"
              v-model="form.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('Contact_Number')"
            prop="phone"
          >
            <el-input
              :placeholder="$t('please_input')"
              v-model="form.phone"
              class="input-with-select phone-input"
            >
              <el-select
                style="width: 100px;"
                class="phoneTitle"
                v-model="phoneTitle"
                slot="prepend"
                filterable
                :placeholder="$t('root.selectPls')"
                :filter-method="dataFilter"
              >
                <el-option
                  v-for="item in phoneList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                  <span>{{`${item.label} ${item.description}`}}</span>
                </el-option>
              </el-select>
            </el-input>
          </el-form-item>
<!--          <el-form-item
            label="收货地区"
            prop="region"
          >
            <div class="region-block">
              <area-cascader
                class="region"
                :level="1"
                type="text"
                placeholder="请选择收货地址"
                :data="regionData"
                v-model='form.region'
              ></area-cascader>
            </div>
          </el-form-item>-->
          <el-form-item
            :label="$t('Train.lecturesAddr')"
            prop="address"
          >
            <el-input
              :placeholder="$t('please_input')"
              v-model="form.address"
            ></el-input>
          </el-form-item>
        </el-form>
    </div>
    <div class="footer-box padding20"
         slot="footer"
    >
      <el-button
        class="open-btn"
        style="width: 100%"
        type="primary"
        @click="submitHandle"
      >{{$t('save')}}</el-button>
    </div>
  </copy-shell>
</template>

<script>
import { addOrEditShippingAddress } from '@/api/userCenter'
import copyShell from '@/components/common/copyShell';
import { pca, pcaa } from 'area-data';
import { getDictListByType } from '@/api/home.js';
import { getDictByTypeAsync } from '@/utils/cacheService';
export default {
  name: 'shippingAddress',
  components:{
    copyShell,
  },
  props: {
    addressInfo: {
    },
    dialogShow:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      phoneTitle: '+86',//选择手机号码地区列表的值,
      phoneList:[],
      phoneListMaster:[],
      form:{
        name: '',
        phone: '',
        region: '',
        address: '',
      },
      rules:{
        name: [
          {required: true,message: '请输入收货姓名',trigger: 'blur'},
        ],
        phone: [
          {required: true,message: '请输入联系电话',trigger: 'change'},
        ],
        region: [
          {required: true,message: '请选择收货地区',trigger: 'change'},
        ],
        address: [
          {required: true,message: '请输入详细地址',trigger: 'blur'},
        ],
      }
    };
  },
  watch:{
    addressInfo(newValue){
      if(newValue){
        this.form.name = newValue.name;
        this.form.phoneTitle = newValue.nationCode;
        this.phoneTitle = newValue.nationCode;
        this.form.phone = newValue.phone;
        this.form.region = newValue.city;
        this.form.address = newValue.address;
      }
    }
  },
  computed: {
    regionData() {
      return pcaa;
    },
  },
  created() {
    this.getDictList('phoneList');
  },
  methods: {
    closeHandle() {
      this.$emit('close');
    },
    getDictList(type){
      getDictByTypeAsync(getDictListByType, type).then((data) => {
        if(data.length){
          if(data[0].type == 'phoneList') {
            this.phoneList = data;
            this.phoneListMaster = data;
          }
        }
      })
    },
    dataFilter(val){
      this.phoneTitle = val;
      if (val) { //val存在
        this.phoneList = this.phoneListMaster.filter((item) => {
          if((item.label.indexOf(val) > -1) || (item.description.toUpperCase().indexOf(val.toUpperCase()) > -1)){
            return true
          }
        })
      } else {
        //val为空时，还原数组
        this.phoneList = this.phoneListMaster;
      }
    },
    submitHandle() {
      this.$refs.form.validate((valid) => {
        if(valid){
          // 添加或编辑
          addOrEditShippingAddress({
            name: this.form.name,
            nationCode: this.phoneTitle,
            phone: this.form.phone,
            // city: this.form.region,
            address: this.form.address,
          }).then((res) => {
            if(res&&res.code&&res.code == 200){
              console.log(res);
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$emit('add-or-edit-success');
            }else{
              this.$message.error(res.msg);
            }
          })
        }else {
          console.log('no-pass');
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.shipping-address {
  /deep/ .area-select {
    width: 100%!important;
    .cascader-menu-list {
      min-width: 136px;
    }
    .area-selected-trigger {
      padding-top: 0;
    }
  }
}
</style>
